import { useEffect, useState } from "react";
import { serverNow, syncServerClock } from "../utils/serverTime.js";

const TICK_MS = 30000;

const sameHour = (a, b) =>
  a.getHours() === b.getHours() &&
  a.getDate() === b.getDate() &&
  a.getMonth() === b.getMonth() &&
  a.getFullYear() === b.getFullYear();

/**
 * La hora actual tal como la ve el servidor.
 *
 * Los horarios son la opinión del kiosko sobre cuándo el local está abierto, y un equipo con el
 * reloj corrido abriría una categoría antes de tiempo o la dejaría cerrada todo el día. Por eso
 * se aplica el desfase del servidor en cada tick, y una sincronización que llega después del
 * montaje corrige el valor sin que nadie más tenga que enterarse.
 *
 * Los horarios tienen granularidad de hora, así que se mantiene la misma referencia mientras la
 * hora no cambie: el tick solo dispara un re-render cuando el resultado de un horario puede haber
 * cambiado, y los memos que dependen de esta fecha (categorías, precarga de imágenes) no se
 * recalculan cada 30 segundos.
 *
 * @param {number} intervalMs - Cada cuánto se revisa el reloj.
 * @returns {Date}
 */
export function useNow(intervalMs = TICK_MS) {
  const [now, setNow] = useState(() => serverNow());

  useEffect(() => {
    let active = true;
    const read = () => {
      if (!active) return;
      setNow((previous) => {
        const next = serverNow();
        return sameHour(previous, next) ? previous : next;
      });
    };

    // La primera sincronización suele llegar mucho antes de que corra el primer tick.
    syncServerClock().then(read);
    const timer = setInterval(() => {
      syncServerClock().then(read);
    }, intervalMs);

    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [intervalMs]);

  return now;
}
